import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { BalanceBarColumn } from "web_myplann/Finances/Components/BalanceBarColumn";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	income: number;
	expenses: number;
};

export const BalanceBarChart: FC<Props> = ({ income, expenses }) => {
	const theme = useTheme();
	const { t } = useResource();
	const max = Math.max(income, expenses);

	return (
		<Stack
			direction="row"
			alignItems="flex-end"
			gap={theme.spacingTokens.section}
			bgcolor={theme.palette.background.paper}
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.sm}
			pb={theme.spacingTokens.lg}
		>
			<BalanceBarColumn
				label={t(Resources.Finances.Result.income)}
				amount={income}
				max={max}
				color={theme.palette.green[500]}
			/>
			<BalanceBarColumn
				label={t(Resources.Finances.Result.expenses)}
				amount={expenses}
				max={max}
				color={theme.palette.red[400]}
			/>
		</Stack>
	);
};
